// import store from "@/state/store";
import middleware from "../middleware/middleware";

const meta = {
    middleware: middleware,
    // resource: 'Auth',
    redirectIfLoggedIn: true,
};

export default [
    {
        path: "/login",
        name: "login",
        component: () => import("@/views/auth/signin.vue"),
        meta: {
            ...meta,
            title: "Login",
        },
    },
    {
        path: "/register",
        name: "Register",
        component: () => import("@/views/auth/signup.vue"),
        meta: {
            ...meta,
            title: "Register",
        },
    },
    {
        path: "/logout",
        name: "logout",
        meta: {
            title: "Logout", authRequired: true,
            // beforeResolve(routeTo, routeFrom, next) {
            //     localStorage.clear();
            //     sessionStorage.clear();
            //     next();
            // },
        },
        component: () => import("@/views/auth/logout/basic.vue")
    },
    // {
    //     path: "/forgot-password",
    //     name: "Forgot password",
    //     component: () => import("@/views/account-ui/forgot-password.vue"),
    //     meta: {
    //         ...meta,
    //         title: "Forgot Password",
    //     },
    // },
]